
export const getScoreColors = (score: number) => {
    if (score >= 90) {
        // High scores: Blue
        return {
            color: '#4239B0',
            borderColor: '#4239B0',
            background: 'linear-gradient(88deg, #0B0086 2.04%, #4239B0 98.34%)', // PRIMARY_PURPLE,
            softBackground: '#4239B033',
        };
    } else if (score >= 70) {
        // Medium-high scores: Teal/Green
        return {
            color: '#118999',
            borderColor: '#118999',
            background: 'linear-gradient(221deg, #118999 29.09%, #1B6E79 70.94%)', // Teal from design
            softBackground: '#11899933',
        };
    } else if (score > 40) {
        // Medium-low scores: Orange
        return {
            color: '#F2994A',
            borderColor: '#F2994A',
            background: 'linear-gradient(112deg, #F27A4A 9.14%, #DB8428 61.94%)', // WARNING_ORANGE
            softBackground: '#F2994A33',
        };
    } else {
        // Low scores: Red
        return {
            color: '#D34059',
            borderColor: '#D34059',
            background: 'linear-gradient(104deg, #D34059 20.16%, #D3586D 93.52%)', // SECONDARY_RED
            softBackground: '#D3405933',
        };
    }
};
export const getScoreLabel = (score: number) => {
    if (score >= 90) {
        return "Top candidat";
    } else if (score >= 70) {
        return "A voir absolument";
    } else if (score > 40) {
        return "On ne sait jamais";
    } else {
        return "A priori c'est mal engagé";
    }
};
